import { Component, OnInit, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-status',
  templateUrl: './confirm-status.component.html',
  styleUrls: ['./confirm-status.component.scss']
})
export class ConfirmStatusComponent implements OnInit {

  @Input() title: string;
  @Input() message: string;

  constructor(private dialogRef: MatDialogRef<ConfirmStatusComponent>) { }

  ngOnInit(): void {
  }

  accept() {
    this.dialogRef.close(true);
  }

}
